module.exports = __webpack_public_path__ + "img/websocket.00118c41.svg";